module.exports = __webpack_public_path__ + "static/media/goat-eating-saag.8e180480.png";